import { render, staticRenderFns } from "./SlideComp.vue?vue&type=template&id=eb0fe83e&scoped=true&"
import script from "./SlideComp.vue?vue&type=script&lang=js&"
export * from "./SlideComp.vue?vue&type=script&lang=js&"
import style0 from "./SlideComp.vue?vue&type=style&index=0&id=eb0fe83e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0fe83e",
  null
  
)

export default component.exports